module.exports = __webpack_public_path__ + "static/media/ss6.57557df2.jpg";